const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', name: 'HomeScreen', component: () => import('pages/Index.vue') },
      { path: 'payment-valitor', name: 'ValitorPayPayment', component: () => import('pages/ValitorPayPayment.vue') },
      { path: 'payment-verifone', name: 'VerifonePayment', component: () => import('pages/VerifonePayment.vue') },
      { path: 'complete', name: 'OrderComplete', component: () => import('pages/Complete.vue') },
    ],
  },
];

// Always leave this as last one
routes.push({
  path: '*',
  component: () => import('pages/Error404.vue'),
});

export default routes;
